// lib/studio-artboard.ts
// A Vector project is a fixed artboard, not the infinite canvas: the viewport may move, but the
// artboard never leaves the window. The pan is clamped per axis so that, when the artboard fits
// the window, it stays entirely inside a margin, and when it is larger than the window (zoomed in),
// the window stays entirely over it. Pure, so the kernel's wheel, drag and animation paths share it.
import type { Rect } from '#types/types';

export const ARTBOARD_VIEWPORT_MARGIN_PX = 24;

export const clampPanToArtboard = (
  pan: { x: number; y: number },
  zoom: number,
  artboard: Rect,
  viewport: { width: number; height: number },
  margin: number = ARTBOARD_VIEWPORT_MARGIN_PX,
): { x: number; y: number } => {
  const clampAxis = (value: number, origin: number, size: number, extent: number): number => {
    // pan + origin * zoom is where the artboard's edge lands on screen.
    const a = margin - origin * zoom;
    const b = extent - margin - size * zoom - origin * zoom;
    const lo = Math.min(a, b);
    const hi = Math.max(a, b);
    return Math.min(hi, Math.max(lo, value));
  };
  return {
    x: clampAxis(pan.x, artboard.x, artboard.w, viewport.width),
    y: clampAxis(pan.y, artboard.y, artboard.h, viewport.height),
  };
};
